import { Grid } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import React from 'react';
import stopIcon from '../../globals/assets/Icon awesome-stop-circle.svg';
import deleteIcon from '../../globals/assets/delete_bucket.svg';
import './longTermMachineList.scss';
import PaginationItem from '@mui/material/PaginationItem';

const LongTermMachineList = () => {
	return (
		<>
			<Grid container className="TitleContainerLongMachine">
				<Grid xs={12} sm={12} md={8} lg={8}>
					<div>
						<span className="TitleName"> {`LongTerm Machine >>`} </span>
						<span className="TrainingName">Training Name</span>
					</div>
				</Grid>
				<Grid xs={12} sm={12} md={4} lg={4}>
					<Grid lg={12} container className="instanceMachineButtonContainer">
						<Grid xs={12} sm={7} md={7} lg={7}>
							<div className="searchInputLong">
								<input type="text" placeholder="Search" />
								<i className="fa fa-search"></i>
							</div>
						</Grid>
						<Grid
							xs={12}
							sm={5}
							md={5}
							lg={5}
							className="instanceMachineButtonDiv"
						>
							<button className="instanceMachineButton">
								Instance Machine
							</button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<Grid container>
				<Grid xs={12} sm={12} md={12} lg={12} className="ParentLongTermMachine">
					<div className="longTermMachineListingDiv">
						<Grid container>
							<Grid
								item
								xs={12}
								sm={12}
								md={9}
								lg={9}
								className="mainListingDiv"
							>
								<Grid
									item
									xs={12}
									sm={12}
									md={12}
									lg={12}
									className="ListingDiv"
								>
									<Grid
										container
										xs={12}
										sm={12}
										md={12}
										lg={12}
										className="listing"
									>
										<Grid xs={12} sm={12} md={2} lg={2} className="item1">
											Sonali Surave
										</Grid>
										<Grid xs={12} sm={12} md={6} lg={6} className="item2">
											VM URL : https://store.epicgames.com/en-US/
										</Grid>
										<Grid xs={12} sm={12} md={4} lg={4} className="item3">
											Action :
											<img src={stopIcon} />
											<img src={deleteIcon} />
											<label className="longTermMachineStatusLabel">
												{' '}
												Running{' '}
											</label>
										</Grid>
									</Grid>
									<Grid
										container
										xs={12}
										sm={12}
										md={12}
										lg={12}
										className="listing"
									>
										<Grid xs={12} sm={12} md={2} lg={2} className="item1">
											Sonali Surave
										</Grid>
										<Grid xs={12} sm={12} md={6} lg={6} className="item2">
											VM URL : https://store.epicgames.com/en-US/
										</Grid>
										<Grid xs={12} sm={12} md={4} lg={4} className="item3">
											Action :
											<img src={stopIcon} />
											<img src={deleteIcon} />
											<label className="longTermMachineStatusLabel">
												{' '}
												Running{' '}
											</label>
										</Grid>
									</Grid>
									<Grid
										container
										xs={12}
										sm={12}
										md={12}
										lg={12}
										className="listing"
									>
										<Grid xs={12} sm={12} md={2} lg={2} className="item1">
											Sonali Surave
										</Grid>
										<Grid xs={12} sm={12} md={6} lg={6} className="item2">
											VM URL : https://store.epicgames.com/en-US/
										</Grid>
										<Grid xs={12} sm={12} md={4} lg={4} className="item3">
											Action :
											<img src={stopIcon} />
											<img src={deleteIcon} />
											<label className="longTermMachineStatusLabel">
												{' '}
												Running{' '}
											</label>
										</Grid>
									</Grid>
									<Grid
										container
										xs={12}
										sm={12}
										md={12}
										lg={12}
										className="listing"
									>
										<Grid xs={12} sm={12} md={2} lg={2} className="item1">
											Sonali Surave
										</Grid>
										<Grid xs={12} sm={12} md={6} lg={6} className="item2">
											VM URL : https://store.epicgames.com/en-US/
										</Grid>
										<Grid xs={12} sm={12} md={4} lg={4} className="item3">
											Action :
											<img src={stopIcon} />
											<img src={deleteIcon} />
											<label className="longTermMachineStatusLabel">
												{' '}
												Running{' '}
											</label>
										</Grid>
									</Grid>
									<Grid
										container
										xs={12}
										sm={12}
										md={12}
										lg={12}
										className="listing"
									>
										<Grid xs={12} sm={12} md={2} lg={2} className="item1">
											Sonali Surave
										</Grid>
										<Grid xs={12} sm={12} md={6} lg={6} className="item2">
											VM URL : https://store.epicgames.com/en-US/
										</Grid>
										<Grid xs={12} sm={12} md={4} lg={4} className="item3">
											Action :
											<img src={stopIcon} />
											<img src={deleteIcon} />
											<label className="longTermMachineStatusLabel">
												{' '}
												Running{' '}
											</label>
										</Grid>
									</Grid>
									<Grid
										container
										xs={12}
										sm={12}
										md={12}
										lg={12}
										className="listing"
									>
										<Grid xs={12} sm={12} md={2} lg={2} className="item1">
											Sonali Surave
										</Grid>
										<Grid xs={12} sm={12} md={6} lg={6} className="item2">
											VM URL : https://store.epicgames.com/en-US/
										</Grid>
										<Grid xs={12} sm={12} md={4} lg={4} className="item3">
											Action :
											<img src={stopIcon} />
											<img src={deleteIcon} />
											<label className="longTermMachineStatusLabel">
												{' '}
												Running{' '}
											</label>
										</Grid>
									</Grid>
									<Grid
										container
										xs={12}
										sm={12}
										md={12}
										lg={12}
										className="listing"
									>
										<Grid xs={12} sm={12} md={2} lg={2} className="item1">
											Sonali Surave
										</Grid>
										<Grid xs={12} sm={12} md={6} lg={6} className="item2">
											VM URL : https://store.epicgames.com/en-US/
										</Grid>
										<Grid xs={12} sm={12} md={4} lg={4} className="item3">
											Action :
											<img src={stopIcon} />
											<img src={deleteIcon} />
											<label className="longTermMachineStatusLabel">
												{' '}
												Running{' '}
											</label>
										</Grid>
									</Grid>
									<Grid
										container
										xs={12}
										sm={12}
										md={12}
										lg={12}
										className="listing"
									>
										<Grid xs={12} sm={12} md={2} lg={2} className="item1">
											Sonali Surave
										</Grid>
										<Grid xs={12} sm={12} md={6} lg={6} className="item2">
											VM URL : https://store.epicgames.com/en-US/
										</Grid>
										<Grid xs={12} sm={12} md={4} lg={4} className="item3">
											Action :
											<img src={stopIcon} />
											<img src={deleteIcon} />
											<label className="longTermMachineStatusLabel">
												{' '}
												Running{' '}
											</label>
										</Grid>
									</Grid>
									<Grid
										container
										xs={12}
										sm={12}
										md={12}
										lg={12}
										className="listing"
									>
										<Grid xs={12} sm={12} md={2} lg={2} className="item1">
											Sonali Surave
										</Grid>
										<Grid xs={12} sm={12} md={6} lg={6} className="item2">
											VM URL : https://store.epicgames.com/en-US/
										</Grid>
										<Grid xs={12} sm={12} md={4} lg={4} className="item3">
											Action :
											<img src={stopIcon} />
											<img src={deleteIcon} />
											<label className="longTermMachineStatusLabel">
												{' '}
												Running{' '}
											</label>
										</Grid>
									</Grid>
									<Grid
										container
										xs={12}
										sm={12}
										md={12}
										lg={12}
										className="listing"
									>
										<Grid xs={12} sm={12} md={2} lg={2} className="item1">
											Sonali Surave
										</Grid>
										<Grid xs={12} sm={12} md={6} lg={6} className="item2">
											VM URL : https://store.epicgames.com/en-US/
										</Grid>
										<Grid xs={12} sm={12} md={4} lg={4} className="item3">
											Action :
											<img src={stopIcon} />
											<img src={deleteIcon} />
											<label className="longTermMachineStatusLabel">
												{' '}
												Running{' '}
											</label>
										</Grid>
									</Grid>
									<Grid
										container
										xs={12}
										sm={12}
										md={12}
										lg={12}
										className="listing"
									>
										<Grid xs={12} sm={12} md={2} lg={2} className="item1">
											Sonali Surave
										</Grid>
										<Grid xs={12} sm={12} md={6} lg={6} className="item2">
											VM URL : https://store.epicgames.com/en-US/
										</Grid>
										<Grid xs={12} sm={12} md={4} lg={4} className="item3">
											Action :
											<img src={stopIcon} />
											<img src={deleteIcon} />
											<label className="longTermMachineStatusLabel">
												{' '}
												Running{' '}
											</label>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
							<Grid item xs={12} sm={12} md={3} lg={3}>
								<Grid container className="filterContainer">
									<Grid
										xs={12}
										sm={12}
										md={12}
										lg={12}
										className="filterFields"
									>
										<div>
											<input placeholder="Student Name" className="TextField" />
										</div>
									</Grid>
									<Grid
										xs={12}
										sm={12}
										md={12}
										lg={12}
										className="filterFields"
									>
										{/* <div className="dropDownField"> */}
										<select class="ui dropdown">
											<option value="">Gender</option>
											<option value="1">Male</option>
											<option value="0">Female</option>
										</select>
										{/* </div> */}
									</Grid>
									<Grid container className="extraMargin">
										<Grid
											xs={12}
											sm={12}
											md={12}
											lg={12}
											className="filterFields clearButton"
										>
											Clear All
										</Grid>
										<Grid
											xs={12}
											sm={12}
											md={12}
											lg={12}
											className="filterFields applyButton"
										>
											Apply
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</div>
					<div className="pegination">
						<Grid container className="pegination">
							<Grid xs={12} sm={6} md={6} lg={6}>
								Total Images - 500
							</Grid>
							<Grid xs={12} sm={6} md={6} lg={6}>
								<Pagination
									count={10}
									color="primary"
									renderItem={(item) => (
										<PaginationItem
											components={{ previous: 'previous', next: 'next' }}
											{...item}
										/>
									)}
								/>
							</Grid>
						</Grid>
					</div>
				</Grid>
			</Grid>
		</>
	);
};

export default LongTermMachineList;
